<template>
	<div class="top-right-btn">
		<el-button size="small" color="#5E93E5" round icon="Search" @click="toggleSearch()">
			<span v-if="showSearch">隐藏</span>
			<span v-else>显示</span>
		</el-button>
		<el-button size="small" type="primary" round icon="Refresh" @click="refresh()">刷新</el-button>
	</div>
</template>

<script setup>
const props = defineProps({
	showSearch: {
		type: Boolean,
		default: true
	},
	columns: {
		type: Array
	}
})

const emits = defineEmits(['update:showSearch', 'queryTable'])

// 显隐数据
const value = ref([])
// 弹出层标题
const title = ref('显示/隐藏')
// 是否显示弹出层
const open = ref(false)

// 搜索
function toggleSearch() {
	emits('update:showSearch', !props.showSearch)
}

// 刷新
function refresh() {
	emits('queryTable')
}

// 右侧列表元素变化
function dataChange(data) {
	for (let item in props.columns) {
		const key = props.columns[item].key
		props.columns[item].visible = !data.includes(key)
	}
}

// 打开显隐列dialog
function showColumn() {
	open.value = true
}

// 显隐列初始默认隐藏列
for (let item in props.columns) {
	if (props.columns[item].visible === false) {
		value.value.push(parseInt(item))
	}
}
</script>

<style scoped lang="scss">
:deep(.el-transfer__button) {
	border-radius: 50%;
	display: block;
	margin-left: 0px;
}

:deep(.el-transfer__button:first-child) {
	margin-bottom: 10px;
}

.my-el-transfer {
	text-align: center;
}
</style>
